/**
 * Evcil Dostumun İhtiyacı (F7-39) vitrin metinleri; `storefront.tr.ts` → `storefrontTr.needsFinder` altına bağlanır.
 * `seed.*` panelde "ürün verisinden ilk taslak" için kullanılır (uzman düzenler ve onaylar).
 */
export const storefrontNeedsTr = {
  title: 'Evcil Dostumun İhtiyacı',
  metaDescription:
    'Dostunuzun türüne, yaşına ve ihtiyacına göre birkaç soruyla günlük bakım rutini önerisi. Veteriner muayenesinin yerine geçmez.',
  lead: 'Birkaç soruyla dostunuz için günlük bir bakım rutini önerelim.',
  privacy: 'Cevaplarınız yalnızca bu tarayıcıda kalır; bize gönderilmez.',
  disclaimer: 'Bu öneri veteriner muayenesinin yerine geçmez.',
  start: 'Başla',
  steps: {
    species: 'Tür',
    basics: 'Temel bilgiler',
    areas: 'Destek alanları',
    questions: 'Sorular',
    result: 'Sonuç',
  },
  progress: 'İlerleme',
  stepOf: 'Adım {{n}} / {{total}}',
  speciesQuestion: 'Dostunuz hangisi?',
  basicsQuestion: 'Dostunuzu biraz tanıyalım',
  age: 'Yaşı',
  ages: { baby: 'Yavru', young: 'Genç', adult: 'Yetişkin', senior: 'Yaşlı' },
  weight: 'Kilosu',
  weights: {
    under_2: '2 kg altı',
    '2_5': '2–5 kg',
    '5_10': '5–10 kg',
    '10_25': '10–25 kg',
    over_25: '25 kg üstü',
  },
  neutered: 'Kısırlaştırıldı mı?',
  neuteredOptions: { yes: 'Evet', no: 'Hayır', unknown: 'Bilmiyorum' },
  reproductive: 'Gebe mi, yavrularını emziriyor mu?',
  reproductiveOptions: { none: 'Hayır', pregnant: 'Gebe', lactating: 'Emziriyor', unknown: 'Bilmiyorum' },
  areasQuestion: 'Hangi konularda destek arıyorsunuz?',
  multipleHint: 'Birden çok seçebilirsiniz.',
  noAreas: 'Bu tür için henüz destek alanı tanımlanmadı.',
  browseSpecies: '{{species}} ürünlerine göz atın',
  back: 'Geri',
  next: 'Devam',
  seeResult: 'Sonucu gör',
  restart: 'Baştan başla',
  change: 'Değiştir',
  answerRequired: 'Devam etmek için bir seçim yapın.',
  resultTitle: 'Dostunuz için önerilen rutin',
  resultLead: '{{count}} ürün öneriyoruz; istemediğinizi rutinden çıkarabilirsiniz.',
  why: 'Neden önerildi',
  usage: 'Kullanım',
  include: 'Rutinde',
  includeLabel: '{{name}} rutinde',
  alternativeFor: 'Önerilen ürün stokta olmadığı için yerine bu ürün geldi.',
  option: 'Seçenek: {{name}}',
  otherOptions: 'Diğer seçenekler ürün sayfasında',
  total: 'Toplam',
  totalNote: '{{count}} ürün seçili. Kargo ve kampanyalar sepette hesaplanır.',
  addAll: 'Hepsini sepete ekle',
  adding: 'Sepete ekleniyor…',
  added: '{{count}} ürün sepete eklendi.',
  goCart: 'Sepete git',
  addFailed: '{{name}} sepete eklenemedi: {{error}}',
  nothingSelected: 'Sepete eklemek için en az bir ürün seçin.',
  empty: 'Cevaplarınıza uygun ürün bulamadık.',
  emptyLead: 'Farklı bir destek alanı seçebilir veya tüm ürünlere göz atabilirsiniz.',
  browseAll: 'Tüm ürünlere göz at',
  emergencyTitle: 'Lütfen önce bir veteriner hekime başvurun',
  emergencyText:
    'Seçtiğiniz durum acil bakım gerektirebilir. Bu durumda ürün önermiyoruz; lütfen vakit kaybetmeden bir veteriner hekime başvurun.',
  emergencyLinks: 'Size yardımcı olabilecek sayfalar',
  emergencyBack: 'Cevabımı değiştir',
  bundle: 'Bu rutinde geçerli kampanya',
  answersTitle: 'Cevaplarınız',
  summary: {
    title: 'Rutin özeti',
    empty: 'Soruları cevapladıkça öneriler burada belirir.',
    show: 'Rutini gör ({{count}})',
    pending: 'Kalan sorular: {{count}}',
  },
  chat: {
    greeting: 'Merhaba! Birkaç kısa soruyla dostunuz için bir bakım rutini hazırlayalım.',
    log: 'Sorular ve cevaplarınız',
    question: 'Soru',
    answer: 'Cevabınız',
    edit: 'Cevabı değiştir',
    resultIntro: 'Cevaplarınıza göre önerdiğimiz rutin:',
    fixed: 'Bu sorular sabittir ve her ziyaretçiye aynı kurallarla cevap verilir.',
  },
  savePet: {
    title: 'Dostumu kaydet',
    lead: 'Temel bilgileri hesabınıza kaydedin; bir dahaki sefere yeniden girmeyin. Sağlık sorularına verdiğiniz cevaplar kaydedilmez.',
    name: 'Dostunuzun adı',
    consent:
      'Dostumun türü, yaşı, kilo aralığı, kısırlaştırma ve gebelik/emzirme bilgisi ile seçtiğim destek alanlarının hesabımda saklanmasına ve bana öneri göstermek için kullanılmasına açık rıza veriyorum. Bu kaydı istediğim zaman Hesabım sayfasından silebilirim.',
    save: 'Dostumu kaydet',
    saved: 'Dostunuz kaydedildi.',
    login: 'Kaydetmek için giriş yapın',
  },
  pets: {
    title: 'Kayıtlı dostlarım',
    lead: 'İhtiyaç bulucuda açık rızanızla kaydettiğiniz temel bilgiler.',
    use: '{{name}} için başla',
    unnamed: '{{species}} dostum',
    delete: 'Sil',
    deleteLabel: '{{name}} kaydını sil',
    deleted: 'Kayıt silindi.',
    empty: 'Kayıtlı dostunuz yok.',
    open: 'İhtiyaç bulucuyu aç',
  },
  seed: {
    reason: 'Seçtiğiniz “{{area}}” destek alanı için.',
    emergencyQuestion: 'Dostunuzda şu an aşağıdakilerden biri var mı?',
    emergencyHelp: 'Bunlardan biri varsa ürün önermiyoruz; lütfen önce bir veteriner hekime başvurun.',
    emergencyNone: 'Hiçbiri',
    emergency: {
      breathing: 'Nefes almakta zorlanıyor',
      bleeding: 'Durmayan bir kanama var',
      poison: 'Zehirli bir şey yemiş veya yalamış olabilir',
      seizure: 'Nöbet geçiriyor',
      collapse: 'Bayıldı veya ayağa kalkamıyor',
      not_eating: 'Bir günden uzun süredir hiç yemiyor veya içmiyor',
    },
    pregnancyNote: 'Ürünün uyarı metninde gebelik veya emzirme geçiyor.',
    intro:
      'Dostunuzun türünü, yaşını ve destek aradığınız konuları seçin; size uygun bir günlük bakım rutini önerelim.',
    emergencyText:
      'Seçtiğiniz durum acil bakım gerektirebilir. Bu durumda ürün önermiyoruz; lütfen vakit kaybetmeden bir veteriner hekime başvurun.',
  },
};
